import { createContext, useContext } from "react";

import type { Dimension } from "../../../types";

type ColumnsContextValue = {
  collapseOnMobile: boolean;
  collapseOnTablet: boolean;
  reverseOnCollapse?: boolean;
  mobileSpace: Dimension | null;
  tabletSpace: Dimension | null;
  desktopSpace: Dimension | null;
};

export const ColumnsContext = createContext<ColumnsContextValue>({
  collapseOnMobile: false,
  collapseOnTablet: false,
  reverseOnCollapse: false,
  mobileSpace: "none",
  tabletSpace: "none",
  desktopSpace: "none"
});

export const useColumnsContext = () => useContext(ColumnsContext);
